module.exports = __webpack_public_path__ + "img/who.fffa26a1.jpg";